import { UserPermissions } from '@creditsights/api-ui-web';
import { NotificationMode, RiskProductAlert } from '../../../../../models/Preference';
import { hasPermissionToRp } from '../../../../../utils/permissionsUtils';
import { WatchList } from '../../../../../models/WatchList';

export interface AlertOption<TValue extends string> {
  value: TValue;
  label: string;
}

export const emailAlertOptions: AlertOption<NotificationMode>[] = [
  {
    label: 'Instant',
    value: NotificationMode.Instant,
  },
  {
    label: 'Digest',
    value: NotificationMode.Digest,
  },
];

export const riskProductAlertOptions: AlertOption<RiskProductAlert>[] = [
  {
    label: 'Daily',
    value: RiskProductAlert.Daily,
  },
  {
    label: 'Weekly',
    value: RiskProductAlert.Weekly,
  },
];

export const hasAnyAlertSelected = (
  userPermissions: UserPermissions | undefined,
  emailAlerts: Pick<WatchList, 'mode' | 'modeResearch' | 'modeCovenants' | 'modeNews'>,
  riskProductAlert: RiskProductAlert
): boolean => {
  const hasAnyBasicAlert =
    userPermissions?.hasAccessToStandardAlerts() &&
    [emailAlerts.mode, emailAlerts.modeResearch, emailAlerts.modeCovenants, emailAlerts.modeNews].some(
      (item) => item !== undefined && item !== NotificationMode.None
    );

  if (hasPermissionToRp(userPermissions)) {
    return hasAnyBasicAlert || riskProductAlert !== RiskProductAlert.None;
  }
  return !!hasAnyBasicAlert;
};
